// Copyright (c) Docugami, Inc. All rights reserved.

import { BindingMetadata } from "networking/reportsApi";
import { FlagEntryBindingInput, createOperationId, useAddFlagToBindingMutation, useRemoveFlagFromBindingMutation } from "store/reports/reportsSlice";
import { hasDiligenceFlag } from "utils/DiligenceReportUtils";
import { useCallback } from "react";
import { selectReportContext } from "store/reports/selectors";
import { useAppSelector } from "./redux";

export function useFlagBinding() {
    const [triggerAddFlag] = useAddFlagToBindingMutation();
    const [triggerRemoveFlag] = useRemoveFlagFromBindingMutation();
    const context = useAppSelector(selectReportContext);

    const flagBinding = useCallback(async (reportId: string, entryId: string, folderId: string, spanId?: string, metadata?: BindingMetadata) => {
        const isFlagged = hasDiligenceFlag(metadata);
        const flagBindingRequest: FlagEntryBindingInput = {
            reportId: reportId,
            context: context!,
            request: {
                entryId: entryId,
                folderId: folderId,
                spanId: spanId,
                operationId: createOperationId()
            }
        }

        if (isFlagged) {
            await triggerRemoveFlag(flagBindingRequest)
        } else {
            await triggerAddFlag(flagBindingRequest)
        }
    }, [triggerRemoveFlag, triggerAddFlag, context]);

    return flagBinding;
}
